module.exports = __webpack_public_path__ + "img/img_upload_data.09ec1fe6.png";